import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "coach-create" }
const _hoisted_2 = { class: "coach-create-content" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "photo-section" }
const _hoisted_5 = { class: "photo-upload" }
const _hoisted_6 = {
  key: 0,
  class: "photo-preview"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-group checkbox-group" }
const _hoisted_18 = { class: "checkbox-label" }
const _hoisted_19 = { class: "form-section" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "specialty-dropdown" }
const _hoisted_23 = {
  key: 0,
  class: "specialty-tags"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "form-section" }
const _hoisted_28 = {
  key: 0,
  class: "error-section"
}
const _hoisted_29 = { class: "error" }
const _hoisted_30 = { class: "submit-section" }
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { class: "auth-url-section" }
const _hoisted_33 = { class: "url-input-container" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "modal-footer" }

import { ref, computed, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import InputMolecule from '@/components/molecules/input-molecule/InputMolecule.vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import coachService, {
    CreateCoachData,
  } from '@/services/coach/coach.service';
  import Coach from '@/models/coach/coach.model';
  import {
    SelectOption,
    transformToSelectOptions,
  } from '@/shared/selectOption';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CoachCreateView',
  setup(__props) {

  const router = useRouter();

  // Form data
  const formData = ref<CreateCoachData>({
    coach_name: '',
    coach_lastname: '',
    coach_email: '',
    coach_headline: '',
    coach_bio: '',
    scheduling_link: '',
    license_number: '',
    specialities_description: '',
    years_of_experience: undefined,
    client_count: '',
    price_per_hour: undefined,
    speciality_ids: [],
    free_session_scheduling_link: '',
    free_block_session_link: '',
    individual_session_link: '',
    coach_level: 1,
    is_instructor: false,
  });

  // File handling
  const coachPhoto = ref<File | null>(null);
  const coachPhotoPreview = ref<string>('');
  const photoInput = ref<HTMLInputElement | null>(null);

  // Form state
  const loading = ref(false);
  const errors = ref<Record<string, string>>({});

  // Success modal
  const showSuccessModal = ref(false);
  const authorizationUrl = ref('');
  const showCopiedMessage = ref(false);

  // Specialties
  const specialityOptions = ref<SelectOption[]>([]);
  const selectedSpecialities = ref<SelectOption[]>([]);

  // Computed for form validation
  const isFormValid = computed(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid =
      formData.value.coach_email && emailRegex.test(formData.value.coach_email);

    return (
      formData.value.coach_name &&
      formData.value.coach_lastname &&
      isEmailValid &&
      formData.value.coach_headline &&
      coachPhoto.value
    );
  });

  // Handle file selection
  const handlePhotoChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/avif'];
      if (!allowedTypes.includes(file.type)) {
        errors.value.photo =
          'Invalid file type. Please select JPEG, PNG, or AVIF image.';
        return;
      }

      // Validate file size (optional, e.g., max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        errors.value.photo =
          'File size too large. Please select a file under 5MB.';
        return;
      }

      coachPhoto.value = file;
      errors.value.photo = '';

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        coachPhotoPreview.value = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  };

  // Trigger file input
  const triggerPhotoUpload = () => {
    photoInput.value?.click();
  };

  // Email validation
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      formData.value.coach_email &&
      !emailRegex.test(formData.value.coach_email)
    ) {
      errors.value.email = 'Please enter a valid email address.';
    } else {
      errors.value.email = '';
    }
  };

  // Submit form
  const submitForm = async () => {
    validateEmail();

    if (!isFormValid.value) {
      errors.value.form =
        'Please fill in all required fields with valid information.';
      return;
    }

    loading.value = true;
    errors.value = {};

    try {
      const files = coachPhoto.value ? [coachPhoto.value] : undefined;
      const response = await coachService.create(formData.value, files);

      if (response.data) {
        // Type assertion for response data with additional fields
        const responseData = response.data as Coach & {
          coach_id?: string;
          authorization_url?: string;
        };
        if (responseData.coach_id) {
          // Show success modal with authorization URL
          authorizationUrl.value = responseData.authorization_url || '';
          showSuccessModal.value = true;
        }
      } else {
        errors.value.form = response.message || 'Failed to create coach.';
      }
    } catch (error) {
      console.error('Error creating coach:', error);
      errors.value.form = 'An error occurred while creating the coach.';
    } finally {
      loading.value = false;
    }
  };

  // Fetch specialities
  const fetchSpecialities = async () => {
    try {
      const response = await coachService.getSpecialities();
      specialityOptions.value = transformToSelectOptions(
        response.data,
        'speciality_id',
        'speciality_name',
      );
    } catch (error) {
      console.error('Error fetching specialities:', error);
      errors.value.specialities = 'Failed to load specialities.';
    }
  };

  // Add specialty
  const addSpecialty = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    const specialtyId = target.value;

    if (specialtyId && selectedSpecialities.value.length < 3) {
      const specialty = specialityOptions.value.find(
        (s) => s.id === specialtyId,
      );
      if (
        specialty &&
        !selectedSpecialities.value.some((s) => s.id === specialtyId)
      ) {
        selectedSpecialities.value.push(specialty);
        formData.value.speciality_ids = selectedSpecialities.value.map(
          (s) => s.id,
        );
      }
    }
    target.value = ''; // Reset the select
  };

  // Remove specialty
  const removeSpecialty = (specialty: SelectOption) => {
    selectedSpecialities.value = selectedSpecialities.value.filter(
      (s) => s.id !== specialty.id,
    );
    formData.value.speciality_ids = selectedSpecialities.value.map((s) => s.id);
  };

  // Available specialities (excluding already selected ones)
  const availableSpecialities = computed(() => {
    return specialityOptions.value.filter(
      (option) =>
        !selectedSpecialities.value.some(
          (selected) => selected.id === option.id,
        ),
    );
  });

  // Copy URL to clipboard
  const copyAuthUrl = async () => {
    try {
      // Try modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(authorizationUrl.value);
      } else {
        // Fallback for older browsers or insecure contexts
        fallbackCopyTextToClipboard(authorizationUrl.value);
      }

      // Show copied message
      showCopiedMessage.value = true;
      setTimeout(() => {
        showCopiedMessage.value = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Try fallback method
      fallbackCopyTextToClipboard(authorizationUrl.value);
    }
  };

  // Fallback copy method for older browsers or insecure contexts
  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        // Show copied message
        showCopiedMessage.value = true;
        setTimeout(() => {
          showCopiedMessage.value = false;
        }, 2000);
      } else {
        console.error('Fallback: Unable to copy to clipboard');
      }
    } catch (err) {
      console.error('Fallback: Unable to copy to clipboard', err);
    }

    document.body.removeChild(textArea);
  };

  // Close modal and navigate to coaches list
  const closeSuccessModal = () => {
    showSuccessModal.value = false;
    router.push('/coaches-list');
  };

  // Initialize data
  onMounted(() => {
    fetchSpecialities();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopbarOrganism, {
      linkText: "Back to coaches",
      showIcon: true,
      icon: "angleLeft",
      primaryButtonText: "Create Coach",
      route: "/coachesList",
      onPrimaryClick: submitForm,
      primaryButtonDisabled: !isFormValid.value || loading.value
    }, null, 8, ["primaryButtonDisabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[34] || (_cache[34] = _createElementVNode("h2", null, "Create New Coach", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Coach Photo *", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              ref_key: "photoInput",
              ref: photoInput,
              type: "file",
              accept: "image/jpeg,image/png,image/avif",
              onChange: handlePhotoChange,
              style: {"display":"none"}
            }, null, 544),
            (coachPhotoPreview.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: coachPhotoPreview.value,
                    alt: "Coach photo preview"
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            _createVNode(ButtonAtom, {
              class: "btn btn-secondary",
              onClick: triggerPhotoUpload,
              disabled: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(coachPhotoPreview.value ? 'Change Photo' : 'Upload Photo'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (errors.value.photo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.photo), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Basic Information", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(InputMolecule, {
              title: "First Name*",
              label: "Coach's first name",
              id: "coach_name",
              placeholder: "Enter first name",
              modelValue: formData.value.coach_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.coach_name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(InputMolecule, {
              title: "Last Name*",
              label: "Coach's last name",
              id: "coach_lastname",
              placeholder: "Enter last name",
              modelValue: formData.value.coach_lastname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.coach_lastname) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(InputMolecule, {
            title: "Email*",
            label: "Coach's email address",
            id: "coach_email",
            placeholder: "Enter email address",
            type: "email",
            modelValue: formData.value.coach_email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.coach_email) = $event)),
            onBlur: validateEmail
          }, null, 8, ["modelValue"]),
          (errors.value.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errors.value.email), 1))
            : _createCommentVNode("", true),
          _createVNode(InputMolecule, {
            title: "Headline*",
            label: "Professional headline",
            id: "coach_headline",
            placeholder: "e.g., Certified Life Coach & Mental Health Professional",
            modelValue: formData.value.coach_headline,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.coach_headline) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_12, [
            _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Bio", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "coach_bio" }, "Coach's biography", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "coach_bio",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.coach_bio) = $event)),
              placeholder: "Tell us about the coach's background and expertise...",
              rows: "4",
              class: "textarea"
            }, null, 512), [
              [_vModelText, formData.value.coach_bio]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[26] || (_cache[26] = _createElementVNode("h3", null, "Professional Information", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(InputMolecule, {
              title: "Years of Experience",
              label: "Years of professional experience",
              id: "years_of_experience",
              placeholder: "e.g., 5",
              type: "number",
              modelValue: formData.value.years_of_experience?.toString() || '',
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
                formData.value.years_of_experience = $event
                  ? Number($event)
                  : undefined
              ))
            }, null, 8, ["modelValue"]),
            _createVNode(InputMolecule, {
              title: "Client Count",
              label: "Number of clients served",
              id: "client_count",
              placeholder: "e.g., 100+",
              modelValue: formData.value.client_count,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.client_count) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(InputMolecule, {
              title: "Price per Hour",
              label: "Hourly rate in USD",
              id: "price_per_hour",
              placeholder: "e.g., 150",
              type: "number",
              modelValue: formData.value.price_per_hour?.toString() || '',
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
                formData.value.price_per_hour = $event ? Number($event) : undefined
              ))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_16, [
              _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Coach Level", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("label", { for: "coach_level" }, "Select coach experience level", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "coach_level",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.coach_level) = $event)),
                class: "select-input"
              }, _cache[21] || (_cache[21] = [
                _createElementVNode("option", { value: "1" }, "Level 1", -1),
                _createElementVNode("option", { value: "2" }, "Level 2", -1),
                _createElementVNode("option", { value: "3" }, "Level 3", -1)
              ]), 512), [
                [_vModelSelect, formData.value.coach_level]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.is_instructor) = $event)),
                class: "checkbox-input"
              }, null, 512), [
                [_vModelCheckbox, formData.value.is_instructor]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "checkbox-text" }, "Is Instructor", -1))
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "checkbox-description" }, " Check if this coach is also an instructor ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[32] || (_cache[32] = _createElementVNode("h3", null, "Specialties", -1)),
          _createElementVNode("div", _hoisted_20, [
            _cache[27] || (_cache[27] = _createElementVNode("h4", null, "Specialties Description", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "specialities_description" }, "Description of specialties", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "specialities_description",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.specialities_description) = $event)),
              placeholder: "Describe the coach's areas of specialization...",
              rows: "3",
              class: "textarea"
            }, null, 512), [
              [_vModelText, formData.value.specialities_description]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[30] || (_cache[30] = _createElementVNode("h4", null, "Specialties", -1)),
            _cache[31] || (_cache[31] = _createElementVNode("label", { for: "speciality_ids" }, "Select coach specialties (maximum 3)", -1)),
            _createElementVNode("div", _hoisted_22, [
              (selectedSpecialities.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSpecialities.value, (specialty) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: specialty.id,
                        class: "specialty-tag"
                      }, [
                        _createTextVNode(_toDisplayString(specialty.value) + " ", 1),
                        _createElementVNode("span", {
                          class: "remove-tag",
                          onClick: ($event: any) => (removeSpecialty(specialty))
                        }, "×", 8, _hoisted_24)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (selectedSpecialities.value.length < 3)
                ? (_openBlock(), _createElementBlock("select", {
                    key: 1,
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (addSpecialty($event))),
                    class: "specialty-select"
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("option", { value: "" }, "Choose a specialty...", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSpecialities.value, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.id,
                        value: option.id
                      }, _toDisplayString(option.value), 9, _hoisted_25))
                    }), 128))
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            (errors.value.specialities)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(errors.value.specialities), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[33] || (_cache[33] = _createElementVNode("h3", null, "Contact Information", -1)),
          _createVNode(InputMolecule, {
            title: "Scheduling Link",
            label: "Link for booking first appointment of block sessions (paid event)",
            id: "scheduling_link",
            placeholder: "https://calendly.com/coach-name",
            modelValue: formData.value.scheduling_link,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.scheduling_link) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InputMolecule, {
            title: "Free Block Scheduling Link",
            label: "Link for booking free block session (3 sessions)",
            id: "free_block_scheduling_link",
            placeholder: "https://calendly.com/coach-name",
            modelValue: formData.value.free_block_session_link,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.free_block_session_link) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InputMolecule, {
            title: "Individual Session Link",
            label: "Link for booking individual session",
            id: "individual_session_link",
            placeholder: "https://calendly.com/coach-name",
            modelValue: formData.value.individual_session_link,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.individual_session_link) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InputMolecule, {
            title: "Free Session Scheduling Link",
            label: "Link for booking free sessions",
            id: "free_session_scheduling_link",
            placeholder: "https://calendly.com/coach-name",
            modelValue: formData.value.free_session_scheduling_link,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.free_session_scheduling_link) = $event))
          }, null, 8, ["modelValue"])
        ]),
        (errors.value.form)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, _toDisplayString(errors.value.form), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(ButtonAtom, {
            class: "btn btn-primary",
            onClick: submitForm,
            disabled: !isFormValid.value || loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(loading.value ? 'Creating...' : 'Create Coach'), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    (showSuccessModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: closeSuccessModal
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "modal-header" }, [
              _cache[35] || (_cache[35] = _createElementVNode("h3", null, "Coach Created Successfully!", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: closeSuccessModal
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[37] || (_cache[37] = _createElementVNode("p", { class: "success-message" }, " The coach profile has been created successfully. Please send this authorization link to the coach to allow our application to manage their meetings. ", -1)),
              _createElementVNode("div", _hoisted_32, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { for: "auth-url" }, "Authorization URL:", -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("input", {
                    id: "auth-url",
                    type: "text",
                    value: authorizationUrl.value,
                    readonly: "",
                    class: "auth-url-input"
                  }, null, 8, _hoisted_34),
                  _createVNode(ButtonAtom, {
                    class: _normalizeClass(`btn ${
                  showCopiedMessage.value ? 'btn-success' : 'btn-secondary'
                } copy-btn`),
                    onClick: copyAuthUrl,
                    disabled: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showCopiedMessage.value ? 'Copied!' : 'Copy'), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(ButtonAtom, {
                class: "btn btn-primary",
                onClick: closeSuccessModal,
                disabled: false
              }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createTextVNode(" Continue to Coaches List ")
                ])),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})